import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import useLockScroll from '../hooks/use-lock-scroll';

function ModalContainer({ children, target }) {

    useLockScroll(target);

    const containerRef = useRef(document.createElement('div'));

    useEffect(() => {

        const element = containerRef.current;
        const targetElement = document.querySelector(target);

        element.className = 'webmed-modal-container';
        element.dataset.target = target;
        targetElement.appendChild(element);

        return () => {

            targetElement.removeChild(element);

        };

    }, []);

    return createPortal(
        children,
        containerRef.current
    );

}

ModalContainer.propTypes = {
    target: PropTypes.string,
};

export default ModalContainer;
